<template>
  <div class="help-center-button" @click="emit('click')">
    <h5>{{ title }}</h5>

    <p>{{ description }}</p>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
  description: string;
}>();

const emit = defineEmits<{
  (e: "click"): void;
}>();
</script>

<style scoped lang="sass">
.help-center-button
  border: 1px solid $gray-5
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1)
  border-radius: 9px
  padding: 12px 20px
  margin-bottom: 12px

  &:hover
    border-color: $blue-5
    cursor: pointer

h5
  font-size: 14px
  font-weight: 600
  color: $gray-9
  margin: 0
  margin-bottom: 2px

p
  font-size: 12px
  font-weight: 400
  color: $gray-8
  margin: 0
</style>
